import { first } from 'rxjs/operators';
import { RateLosService } from '../ratelos-yieldmax.service';
import { RateLos } from '../ratelos-yieldmax';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RatesLosComponent } from '../ratelos-yieldmax/ratelos-yieldmax.component';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-rateLos-list',
    templateUrl: './ratelos-yieldmax-list.component.html',
    styleUrls: ['./ratelos-yieldmax-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class RatesLosListComponent implements OnInit {
	constructor(
		private rateLosService: RateLosService,
		private alertService: AlertService,
		private messageService: MessageService,
		private activatedRoute: ActivatedRoute,
		private datePipe: DatePipe,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = rateLosService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	ratesLos: any;
	rateLos: RateLos;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	//URL Filter
	filterCreateDay: any;
	filterUpdateDay: any;

	columns: any[] = [
		{ field: 'rateLosId', header: 'Id', width: 'auto' },
		{ field: 'createDate', header: 'Create Date', width: 'auto' },
		{ field: 'lastUpdate', header: 'Update Date', width: 'auto' },
		{ field: 'checkInDate', header: 'CheckIn', width: 'auto' },
		{ field: 'checkOutDate', header: 'CheckOut', width: 'auto' },
		{ field: 'propertyCode', header: 'Property', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			this.activatedRoute.queryParamMap.subscribe(params =>
			{
				this.filterCreateDay = params.get('createDate');
				this.filterUpdateDay = params.get('updateDate');;
			});
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.rateLosId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-rateLos-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if(this.filterCreateDay != null)
			{
				let filterCreateDay = this.addLocalTimeToDateTime(new Date(this.filterCreateDay));
				let date = this.datePipe.transform(filterCreateDay, 'yyyy-MM-ddThh:mm');
				event.filters['createDate'] = {"value":date,"matchMode":"in"};
			}

			if(this.filterUpdateDay != null)
			{
				let filterUpdateDay = this.addLocalTimeToDateTime(new Date(this.filterUpdateDay));
				let date = this.datePipe.transform(filterUpdateDay, 'yyyy-MM-ddThh:mm');
				event.filters['lastUpdate'] = {"value":date,"matchMode":"in"};
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.rateLosService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.ratesLos = res.data.ratesLos;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.ratesLos = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(rateLos: RateLos) {
		try {
			this.formLoading = true;
			this.rateLosService.update(rateLos)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.ratesLos.map((rateLos, i) => {
							if (rateLos.rateLosId === res.data.rateLos.rateLosId) {
								this.ratesLos[i] = res.data.rateLos;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(rateLos: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(rateLos));

			this.formLoading = true;
			this.rateLosService.delete(rateLos.rateLosId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.ratesLos.splice(this.ratesLos.indexOf(rateLos), 1);
						this.recordTotal = this.ratesLos.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'RateLos ' + rateLos.rateLosId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'RateLos ' + rateLos.rateLosId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add RateLos'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RatesLosComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addRateLosCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(rateLos: RateLos) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			rateLos: rateLos,
			title: 'Edit RateLos'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RatesLosComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateRateLosCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteRateLosCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addRateLosCB(rateLos: RateLos) {
		console.log('Adding RateLos: ' + JSON.stringify(rateLos));
		// if we don't have a ratesLos array yet...
		if (!this.ratesLos) {
			this.ratesLos = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.ratesLos.unshift(rateLos);

		// no idea what this is but it is required to update the array
		this.ratesLos = [...this.ratesLos];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RateLos ' + rateLos.rateLosId + ' Added', life: 3000 });
	}

	updateRateLosCB(rateLos: RateLos) {
		console.log('Updating RateLos: ' + JSON.stringify(rateLos));
		let itemIndex = this.ratesLos.findIndex((item: any) => item.rateLosId === rateLos.rateLosId);
		this.ratesLos[itemIndex] = rateLos;

		// no idea what this is but it is required to update the array
		this.ratesLos = [...this.ratesLos];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RateLos ' + rateLos.rateLosId + ' Updated', life: 3000 });
	}

	deleteRateLosCB(rateLos: RateLos) {
		console.log('Removing RateLos: ' + rateLos);
		this.ratesLos.splice(this.ratesLos.indexOf(rateLos), 1);
		this.recordTotal = this.ratesLos.length;

		// no idea what this is but it is required to update the array
		this.ratesLos = [...this.ratesLos];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RateLos ' + rateLos.rateLosId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.ratesLos ? this.first === (this.ratesLos.length - this.rows) : true; }
	isFirstPage(): boolean { return this.ratesLos ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(rateLos: any) {
		if (rateLos?.status) {
			const status = this.statuses.find((e: any) => e.value == rateLos.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime
	 * @returns
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}
}
